import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "./../components/AuthContext";

function LandingPage() {
  const navigate = useNavigate();
  const { setRole,setIsAuthenticated } = useAuth();

  // Reset role when landing page mounts
  useEffect(() => {
    setRole(null);
    setIsAuthenticated(false); // Reset authentication status on landing page
  }, [setRole, setIsAuthenticated]);

  return (
    <div className='container' >

   
    <div className="landing-page">
      {/* Patient Block */}
      <div className="landing-block ">
        <h2 className="landing-heading">For patients</h2>
        <p className="landing-copy">
          Connect to your doctor and improve your health.
        </p>
        <p className="landing-subtext">
          Already have a doctor on Wellness Check? Log in to view your visit
          queue and follow-up needs.
        </p>
        <button
          type="button"
          className="btn btn-primary btn-sm w-100" style={{ backgroundColor: "#0b5ed7", borderColor: "#0b5ed7" }}
          onClick={() => {
            setRole("patient");
            navigate("/patient-login");
          }}
        >
          Log in
        </button>
      </div>

      {/* Doctor Block */}
      <div className="landing-block">
        <h2 className="landing-heading">For doctors</h2>
        <p className="landing-copy">
          Grow your practice with online scheduling.
        </p>
        <button
          type="button"
          className="btn btn-primary btn-sm w-100" style={{ backgroundColor: "#0b5ed7", borderColor: "#0b5ed7" }}
          onClick={() => {
            setRole("doctor");
            navigate("/doctor-login");
          }}
        >
          Log in
        </button>
      </div>
    </div> </div>
  );
}

export default LandingPage;
